import VariablesEntityFieldCardsList from './VariablesEntityFieldCardsList';

export default VariablesEntityFieldCardsList;
